<template>
  <div :class="isMobile ? '' : 'd-flex align-middle justify-center'" style="width: 100%">
    <v-text-field :value="widgetKey" :label="$t('companies.widget_key')" readonly outlined hide-details
      autocomplete="off" spellcheck="false" :loading="isLoading" @click="copyWidgetKey()" v-tooltip="{
        content: $t('companies.widget_key_tooltip'),
        placement: 'bottom-center',
        classes: ['white--text', 'black'],
        targetClasses: ['it-has-a-tooltip'],
        delay: {
          show: 500,
          hide: 500,
        },
      }">
      <v-icon slot="append" :color="widgetKey ? 'green' : 'grey'" @click="copyWidgetKey()" cursor="pointer">
        mdi-content-copy
      </v-icon>
    </v-text-field>
    <v-btn v-if="isManagerPlus" @click="updateWidgetKey()" :disabled="isLoading" :class="isMobile ? 'my-2' : 'mx-2 my-auto'">
      {{ $t("companies.update_widget_key") }}
      <v-icon class="ml-1" color="warning">mdi-reload-alert</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { copyToClipboard } from "@/utils/clipboard";

// FT-226: ключ старого виджета (`rpw_…`) в разделе «Компания». В общем JSON компании ключа нет (сервер
// скрывает колонку), поэтому он приходит отдельным GET и живёт в состоянии поля. AppHeader.changeBranch
// сначала кладёт в стор новый филиал и только после ответа /me.json уводит со страницы — всё это время
// поле живо: ключ сбрасывается и загружается заново, а ответы, начатые в прежнем филиале, отбрасываются,
// иначе на сайт филиала B скопировали бы ключ A. PATCH передаёт id филиала: сервер отказывает (409),
// если пользователь уже в другом. Монтируется только для manager+ (CompanyProfile): GET у сервера тоже manager+.
export default {
  name: "WidgetKeyField",
  props: {
    companyId: { type: Number, default: null },
    isMobile: { type: Boolean, default: false },
  },
  data() {
    return {
      widgetKey: null,
      isLoading: false,
    };
  },
  watch: {
    companyId: {
      immediate: true,
      handler(id) {
        this.widgetKey = null;
        if (id != null) this.loadWidgetKey(id);
      },
    },
  },
  methods: {
    authHeaders() {
      return { headers: { Authorization: this.$store.getters.getAuthToken } };
    },
    keyFrom(response) {
      return (response.data && response.data.widget_key) || null;
    },
    async loadWidgetKey(branchId) {
      try {
        const response = await this.axios.get("/api/v1/company/widget_key", this.authHeaders());
        if (branchId !== this.companyId) return;
        this.widgetKey = this.keyFrom(response);
      } catch (error) {
        if (branchId === this.companyId) this.setError(error, this.$t("errors.error"));
      }
    },
    async copyWidgetKey() {
      if (!this.widgetKey) return;
      try {
        await this.writeClipboard(this.widgetKey);
        this.$notify(this.$t("companies.copy_widget_key_success"), "", "success", 3000);
      } catch (error) {
        this.$notify(this.$t("custom.copy_error"), "", "error");
      }
    },
    writeClipboard(text) {
      return copyToClipboard(text);
    },
    async updateWidgetKey() {
      const branchId = this.companyId; // филиал на момент нажатия
      const confirmed = await this.$confirm({
        title: this.$t("custom.you_sure_title"),
        text: this.$t("companies.update_widget_key_confirm"),
        icon: "mdi-alert-outline",
        iconColor: "warning",
        iconSize: 72,
        iconPosition: "top",
        confirmButtonText: this.$t("custom.yes"),
        confirmButtonColor: "primary",
        cancelButtonText: this.$t("custom.no"),
        cancelButtonColor: "grey darken-1",
        useFilledButtons: true,
        maxWidth: 450,
      });
      if (!confirmed) return;

      this.isLoading = true;
      try {
        const response = await this.axios.patch(
          "/api/v1/company/update_widget_key",
          { expected_company_id: branchId },
          this.authHeaders()
        );
        if (branchId !== this.companyId) return;
        this.widgetKey = this.keyFrom(response);
        this.$notify(this.$t("companies.update_widget_key_success"), "", "success", 3000);
      } catch (error) {
        const status = error.response && error.response.status;
        if (status === 409) {
          this.$notify(this.$t("companies.widget_key_branch_changed"), "", "warning");
        } else if (status === 403) {
          this.$notify(this.$t("errors.no_access"), "", "warning");
        } else {
          this.setError(error, this.$t("errors.error"));
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
